export const isStaff = user => user?.code === 55;
export const hasMenu = (user, menu) => user?.code === 44 || (isStaff(user) && user.menus?.includes(menu));
export function filterMenus(items, user) {
  return items.flatMap(item => {
    if (item.subMenu) {
      const subMenu = filterMenus(item.subMenu, user);
      return subMenu.length ? [{ ...item, subMenu }] : [];
    }
    return hasMenu(user, item.link) ? [item] : [];
  });
}
const aliases = { '/add-product': '/products', '/edit-product': '/products', '/product': '/products', '/event': '/events', '/article': '/articles', '/blog': '/blogs' };
export function canOpen(user, pathname) {
  if (!isStaff(user)) return true;
  const root = '/' + pathname.split('/')[1];
  const menu = aliases[root];
  if (menu) return hasMenu(user, menu);
  return (user.menus || []).some(path => pathname === path || (path !== '/' && pathname.startsWith(path + '/')));
}
